module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"userMenu":{"myAccountBtnTitle":"My Account","logoutBtnTitle":"Logout"}}}')
  delete Component.options._Ctor
}
